import React from 'react';
import SEO from '@/components/SEO';
import FormDebugger from '@/components/debug/FormDebugger';
import FormTester from '@/components/debug/FormTester';
import ProductionReadinessChecker from '@/components/debug/ProductionReadinessChecker';

const FormDebug = () => {
  return (
    <>
      <SEO 
        title="Form Testing & Debugging - SeniorThrive Admin"
        description="Test and debug form integrations"
        noindex={true}
      />
      <div className="min-h-screen bg-background">
        <div className="container mx-auto py-6">
          <div className="mb-8">
            <h1 className="text-3xl font-bold mb-2">Form Testing & Debugging</h1>
            <p className="text-muted-foreground">
              Systematically test all forms with dummy data and debug integration issues.
            </p>
          </div>
          
          <div className="grid grid-cols-1 gap-8">
            <ProductionReadinessChecker />
            <FormTester />
            <FormDebugger />
          </div>
        </div>
      </div>
    </>
  );
};

export default FormDebug;